import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

import "../fontAwesome";

declare global {
  interface Window {
    hbspt: any;
  }
}

const PartnerBadges = () => {
  const badges = [
    "advanced-tier-services-badge",
    "ai-services-competency-badge",
    "amazon-connect-delivery-badge",
    "isv-accelerate-badge",
    "aws-marketplace-badge",
  ];

  return (
    <div className="partner-badges flex-box-blk">
      {badges.map((badge, index) => (
        <figure key={index}>
          <img
            src={`https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/images/${badge}.png`}
            alt={badge.replace(/-/g, " ")}
          />
        </figure>
      ))}
    </div>
  );
};

const teCXnology = [
  {
    label: "Amazon Connect Launch",
    href: "https://icxeed.ai/amazon-connect-launch/",
  },
  {
    label: "Amazon Connect Accelerated",
    href: "https://icxeed.ai/amazon-connect-accelerated/",
  },
  {
    label: "CXperience Builder",
    href: "https://cx.icxeed.ai/",
  },
  {
    label: "Intelligent IVR Design",
    href: "https://icxeed.ai/intelligent-ivr-design/",
  },
  {
    label: "Digital AI Concierge",
    href: "https://icxeed.ai/digital-ai-concierge/",
  },
  {
    label: "CX Perspectives",
    href: "https://icxeed.ai/cx-perspectives/",
  },
];

const FooterLinks = () => (
  <>
    <div>
      <h3>COMPANY</h3>
      <ul>
        <li>
          <a
            href="https://www.icxeed.ai/about"
            target="_blank"
            rel="noopener noreferrer"
          >
            About
          </a>
        </li>
        <li>
          <a
            href="https://www.icxeed.ai/library"
            target="_blank"
            rel="noopener noreferrer"
          >
            Library
          </a>
        </li>
        <li>
          <a
            href="https://www.icxeed.ai/aws-cxperts/"
            target="_blank"
            rel="noopener noreferrer"
          >
            AWS CXperts
          </a>
        </li>
        <li>
          <a
            href="https://icxeed.careers/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Careers
          </a>
        </li>
      </ul>
    </div>

    <div>
      <h3>teCXnology</h3>
      <ul>
        {teCXnology.map((item) => (
          <li key={item.label}>
            <a href={item.href} target="_blank" rel="noopener noreferrer">
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  </>
);

const FooterContact = ({ phoneNumber }: { phoneNumber: string }) => (
  <div>
    <h3>CONTACT</h3>
    <div className="contact-section-blk-footer">
      <FontAwesomeIcon icon="phone" />
      <a href="tel:+61438286198">+61 438 286 198</a>
    </div>

    <div className="contact-section-blk-footer">
      <FontAwesomeIcon icon={faEnvelope} />
      <a href="mailto:ryan.rayner@icxeed.ai">ryan.rayner@icxeed.ai</a>
    </div>

    <h3>SOCIALS</h3>
    <ul className="social-links">
      <li>
        <a
          href="https://www.instagram.com/icxeedlife/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={["fab", "instagram"]} className="size-5" />
        </a>
      </li>
      <li>
        <a
          href="https://x.com/iCXeed"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={["fab", "x-twitter"]} className="size-5" />
        </a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/company/icxeed"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={["fab", "linkedin-in"]} className="size-5" />
        </a>
      </li>
      <li>
        <a
          href="https://web.facebook.com/iCXeed/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={["fab", "facebook-f"]} className="size-5" />
        </a>
      </li>
    </ul>
  </div>
);

const FooterInfo = () => (
  <section className="footer-info">
    <p>
      Copyright © <span className="copyright-year">2026</span> iCXeed. All
      Rights Reserved.
    </p>
    <nav aria-label="Footer Navigation">
      <ul>
        <li>
          <a
            href="https://www.icxeed.ai/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </li>
        <li>
          <a
            href="https://www.icxeed.ai/cookie-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy
          </a>
        </li>
        <li>
          <a
            href="https://www.icxeed.ai/terms-and-conditions/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>
        </li>
      </ul>
    </nav>
  </section>
);

const FooterPage = () => {
  useEffect(() => {
    const formConfigs = [
      {
        formId: "5ca6de7f-4566-4b3a-b9f5-e6edb74274e3",
        target: "#stay-in-the-loop-blk",
      },
    ];

    const loadForms = () => {
      formConfigs.forEach(({ formId, target }) => {
        const element = document.querySelector(target);
        if (!element) return;

        if (window.hbspt?.forms?.create) {
          window.hbspt.forms.create({
            region: "na1",
            portalId: "22693629",
            formId,
            target,
          });
        } else {
          setTimeout(loadForms, 500);
        }
      });
    };

    if (!document.getElementById("hubspot-script")) {
      const script = document.createElement("script");
      script.id = "hubspot-script";
      script.src = "https://js.hsforms.net/forms/v2.js";
      script.async = true;
      script.onload = loadForms;
      document.body.appendChild(script);
    } else {
      loadForms();
    }
  }, []);

  return (
    <footer>
      {/* Logo + Badges */}
      <div className="header-logo-section">
        <div className="main-container-blk">
          <section className="flex-box-blk logo-section-footer">
            <figure>
              <img
                src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/images/icxeed-logo-white.png"
                alt="iCXeed Logo"
              />
            </figure>
            <PartnerBadges />
          </section>
        </div>
      </div>

      <div className="divider-blk"></div>

      {/* Footer Links + Contact */}
      <div className="main-container-blk">
        <div className="link-section-footer-blk">
          <FooterLinks />
          <FooterContact phoneNumber={""} />
        </div>
      </div>

      <div className="divider-blk"></div>

      {/* Footer Info */}
      <div className="main-container-blk">
        <FooterInfo />
      </div>
    </footer>
  );
};

export default FooterPage;
